import React from 'react';

// Estilos y componentes compartidos por las pantallas del SG-SST.
export const S = {
  wrap: { padding: 4 },
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16, flexWrap: 'wrap', gap: 12 },
  h1: { color: '#f1f5f9', fontSize: 24, fontWeight: 700, margin: '0 0 4px' },
  sub: { color: '#64748b', fontSize: 14, margin: 0 },
  btn: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnSm: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  btnGhost: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '10px 18px', fontSize: 14, cursor: 'pointer' },
  msg: { padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 640 },
  th: { textAlign: 'left', padding: '10px 12px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', letterSpacing: .5, borderBottom: '1px solid #334155', background: '#0f172a', whiteSpace: 'nowrap' },
  td: { padding: '10px 12px', color: '#94a3b8', borderBottom: '1px solid #1e293b', verticalAlign: 'top' },
  empty: { padding: 30, textAlign: 'center', color: '#64748b' },
  badge: { padding: '2px 9px', borderRadius: 20, fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' },
  link: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 13, marginRight: 10, padding: 0 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 18, width: 600, maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto' },
  modalTitle: { color: '#f1f5f9', fontSize: 18, fontWeight: 700, margin: '0 0 12px' },
  modalBtns: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 18 },
  sec: { color: '#f59e0b', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: .6, margin: '16px 0 10px', paddingBottom: 5, borderBottom: '1px solid #334155' },
  lbl: { display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 4 },
  in: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 11px', color: '#f1f5f9', fontSize: 13.5 },
  ta: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 11px', color: '#f1f5f9', fontSize: 13.5, minHeight: 54, resize: 'vertical', fontFamily: 'inherit' },
};

export const F = ({ l, children }) => <div style={{ marginBottom: 10 }}><label style={S.lbl}>{l}</label>{children}</div>;
export const Grid = ({ children, cols = 2 }) => <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 12 }}>{children}</div>;
export const Grid3 = ({ children }) => <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(140px,1fr))', gap: 12 }}>{children}</div>;

export function Modal({ title, onClose, children, wide }) {
  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, width: wide ? 660 : 600 }} onClick={e => e.stopPropagation()}>
        <h3 style={S.modalTitle}>{title}</h3>
        {children}
      </div>
    </div>
  );
}

export function useFlash() {
  const [msg, setMsg] = React.useState(null);
  const flash = (ok, text) => { setMsg({ ok, text }); setTimeout(() => setMsg(null), 4000); };
  const node = msg ? <div style={{ ...S.msg, background: msg.ok ? '#064e3b' : '#450a0a', color: msg.ok ? '#6ee7b7' : '#fca5a5' }}>{msg.text}</div> : null;
  return [node, flash];
}

export const fdate = (d) => d ? new Date(d).toLocaleDateString('es-CO') : '—';
export const dateVal = (d) => d ? String(d).slice(0, 10) : '';
